<div class="modal-header">
  <h5 class="modal-title">
    Planogram Activity — {{ planogramName || 'Planogram' }}
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body d-flex flex-column" *ngIf="!loading; else loadingTpl">
  <div *ngIf="sharedUsers.length; else noUsersTpl">
    <ul ngbNav #nav="ngbNav" class="nav-tabs">
      <li *ngFor="let user of sharedUsers" [ngbNavItem]="user.id">
        <button ngbNavLink (click)="loadUserEvents(user.id!)">
          {{ user.name }} {{ user.surname }}
        </button>
        <ng-template ngbNavContent>
          <div *ngIf="userEvents[user.id!] === null" class="text-center p-3 text-muted">Loading...</div>
          <div *ngIf="userEvents[user.id!]?.events?.length; else noActivityTpl">
            <ul class="list-group small mb-3">
              <li class="list-group-item d-flex justify-content-between align-items-center"
                  *ngFor="let event of userEvents[user.id!]!.events">
                <span>{{ event.description || event.eventName }}</span>
                <small class="text-muted">{{ event.dateCreated | date:'short' }}</small>
              </li>
            </ul>

            <nav *ngIf="userEvents[user.id!]?.totalPages && userEvents[user.id!]!.totalPages > 1">
              <ul class="pagination justify-content-center">
                <li class="page-item" [class.disabled]="pages[user.id!] === 1">
                  <button class="page-link"
                          (click)="changePage(user.id!, pages[user.id!]-1)"
                          [disabled]="pages[user.id!] === 1">Prev</button>
                </li>
                <li class="page-item disabled">
                  <span class="page-link">
                    Page {{ pages[user.id!] }} of {{ userEvents[user.id!]!.totalPages }}
                  </span>
                </li>
                <li class="page-item" [class.disabled]="pages[user.id!] === userEvents[user.id!]!.totalPages">
                  <button class="page-link"
                          (click)="changePage(user.id!, pages[user.id!]+1)"
                          [disabled]="pages[user.id!] === userEvents[user.id!]!.totalPages">Next</button>
                </li>
              </ul>
            </nav>
          </div>
        </ng-template>
      </li>
    </ul>

    <div [ngbNavOutlet]="nav"></div>
  </div>
</div>

<ng-template #noUsersTpl>
  <div class="text-center text-muted py-3">No shared users for this planogram.</div>
</ng-template>

<ng-template #noActivityTpl>
  <div class="text-center text-muted py-3">No activity for this user.</div>
</ng-template>

<ng-template #loadingTpl>
  <div class="text-center py-3 text-muted">Loading data...</div>
</ng-template>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="close()">Close</button>
</div>